import { Locale } from '@ps-smart-cp/ppfw-client';
import { enumToName, rawValueToEnum } from '../utils';

/** 契約状態 */
enum ContractStatus {
  underContract = '1',
  articleCanceledBefMaturity = '2',
  contractCanceledBefMaturity = '3',
  expired = '5',
  reLeased = '4',
  reLeaseContractCanceled = '6',
  scheduledReLease = '7',
}

const nameConfig = {
  underContract: new Map([[Locale.ja, '契約中']]),
  articleCanceledBefMaturity: new Map([[Locale.ja, '物件中途解約済']]),
  contractCanceledBefMaturity: new Map([[Locale.ja, '契約中途解約済']]),
  reLeased: new Map([[Locale.ja, '再リース済']]),
  expired: new Map([[Locale.ja, '満了済']]),
  reLeaseContractCanceled: new Map([[Locale.ja, '再リース締結済']]),
  scheduledReLease: new Map([[Locale.ja, '再リース予定']]),
};

const toEnum = rawValueToEnum(ContractStatus, ContractStatus.underContract);
const toDisplay = enumToName(ContractStatus, nameConfig);
const toDisplayWithPrefix = enumToName(ContractStatus, nameConfig, { prefix: true });

export const contractStatus = {
  enum: ContractStatus,
  nameConfig,
  toEnum,
  toDisplay,
  toDisplayWithPrefix,
};
export type { ContractStatus };
